import React, { useRef } from "react";
import NewMemberChart from "./NewMemberChart";
import DocNetworkChart from "./DocNetworkChart";
import { useCollabDashboadChartQuery } from "../../app/features/apiSlice";

const DashboardChart = () => {
  const sessionId = useRef(Date.now()).current;
  const { data, isLoading } = useCollabDashboadChartQuery({ sessionId });
  return (
    <>
      <NewMemberChart
        size="6"
        data={data?.newMemberData}
        isLoading={isLoading}
      />
      <DocNetworkChart
        size="6"
        data={data?.personalDocData}
        isLoading={isLoading}
      />
    </>
  );
};

export default DashboardChart;
